import * as client from '../../services/client';
import { TYPES } from 'src/common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchWalkThroughServiceList,
  setEasyWalkThroughFormData,
} from '../actions/easyWalkThroughForm';
import { setPropertyWalkThroughFormData } from './propertyWalkThroughForm';
import { startFormLoading, stopFormLoading } from './loader';
import { setValidation } from './validation';

export const saveScheduledAppointment =
  (formData, serviceRequestId) => (dispatch) => {
    formData['ticketId'] = serviceRequestId;
    dispatch(startFormLoading());

    return client
      .saveScheduledAppointment(formData)
      .then((response) => {
        dispatch(stopFormLoading());
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            toast.success(' ⓘ Appointment has been scheduled.', {
              autoClose: 10000,
              position: 'top-center',
            });
            dispatch(saveStatusDone(serviceRequestId, responsejson.data));
            dispatch(setValidation('Schedule'));
          });
        } else {
          toast.error(
            ' 🚫 Something went wrong with adding a service request, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      })
      .catch((error) => {
        dispatch(stopFormLoading());
        toast.error(
          '🚫 Something went wrong with adding a service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      });
  };

const saveStatusDone = (id, payload) => ({
  type: TYPES.SAVE_STATUS_DONE,
  id,
  payload,
});

export const fetchServiceRequestByIdDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUEST_BY_ID_DONE,
  payload,
});

export const UpdateServiceRequestDone = (payload) => ({
  type: TYPES.UPDATE_SERVICE_REQUEST_DONE,
  payload,
});

export const fetchServiceRequestById = (id) => (dispatch, getState) => {
  return client.getServiceRequestById(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchServiceRequestByIdDone(responsejson));
      });
    }
  });
};

export const updateServiceRequest = (serviceRequest, type) => (dispatch) => {
  dispatch(startFormLoading());
  dispatch(
    setEasyWalkThroughFormData({ walkThroughServiceRequestListLoading: true })
  );
  return client
    .updateServiceRequest(serviceRequest)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.data) {
            toast.success('ⓘ Service request updated successfully.', {
              autoClose: 12000,
              position: 'top-center',
            });
            if (type === 'EditServiceRequest') {
              dispatch(UpdateServiceRequestDone(responsejson.data));
            }
            if (responsejson.data.walkthroughId) {
              dispatch(
                fetchWalkThroughServiceList(responsejson.data.walkthroughId)
              );
            }
          }
        });
      } else {
        dispatch(
          setEasyWalkThroughFormData({
            walkThroughServiceRequestListLoading: false,
          })
        );
        toast.error(
          ' 🚫 Something went wrong with updating a service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      }
    })
    .catch((error) => {
      dispatch(
        setEasyWalkThroughFormData({
          walkThroughServiceRequestListLoading: false,
        })
      );
      toast.error(
        ' 🚫 Something went wrong with updating a service request, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    });
};

export const fetchServiceRequestByAssetId =
  (assetId, walkthroughId, type) => (dispatch) => {
    return client
      .fetchServiceRequestsByAssetId(assetId, walkthroughId)
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(
              setPropertyWalkThroughFormData({ serviceRequests: responsejson })
            );
            if (type !== true) {
              dispatch(
                setPropertyWalkThroughFormData({
                  serviceRequest: responsejson[0],
                })
              );
            }
          });
        }
      });
  };